import debug from "debug";
import { isServerSide } from "@jti/fe-common";
import { MessageBus } from "./MessageBus";
const log = debug("desjti:messageBusHandler");
export const getMessageBus = () => {
    if (isServerSide()) {
        return new MessageBus();
    }
    if (!window.jti) {
        window.jti = {};
    }
    const messageBus = new MessageBus();
    if (!window.jti.messageBus) {
        log("[MESSAGE-BUS] The library is starting. Version: v", messageBus.getVersion());
        window.jti.messageBus = messageBus;
    }
    if (messageBus.getVersion() > window.jti.messageBus.getVersion()) {
        log("[MESSAGE-BUS] The instance of the messageBus has been found with lower version and replaced. Current version is v", messageBus.getVersion());
        window.jti.messageBus = messageBus;
    }
    return window.jti.messageBus;
};
//# sourceMappingURL=messageBusHandler.js.map